<textarea #textarea id="termsAndConditions" class="w-full" [rows]="rows" [readonly]="true" pInputTextarea (scroll)="onScroll(textarea)">{{
  value
}}</textarea>
